import {AsyncPipe} from "@angular/common";
import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ProgressSpinner} from 'primeng/progressspinner';
import {filter, take} from 'rxjs';
import typia from "typia";
import {AnalyticsService} from '../../../services/analytics.service';
import {UserService} from '../../../services/user.service';
import {PaymentService} from "../../../services/payment/payment.service";

@Component({
  selector: 'homey-deferred-nt-success-page',
  standalone: true,
  imports: [ProgressSpinner, AsyncPipe],
  templateUrl: './deferred-nt-success-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeferredNoTrialSuccessPageComponent {
  private readonly analyticsService = inject(AnalyticsService);
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);
  private readonly route = inject(ActivatedRoute);
  private readonly isInterval = typia.createIs<'annual' | 'monthly'>();
  protected readonly settled$ = this.userService.waitUntilDeferredPaymentSettled();

  constructor() {
    const intervalFromQuery = this.route.snapshot.queryParamMap.get('interval');
    const interval = this.isInterval(intervalFromQuery) ? intervalFromQuery : 'unknown';
    void this.analyticsService.sendPaymentSuccess({
      flow: 'initial',
      checkoutLocation: 'deferred-no-trial',
      interval,
      amount: 15,
    });

    this.settled$
      .pipe(
        filter(settled => settled),
        take(1),
      )
      .subscribe(() => {
        void this.router.navigate(
          ['/profile', 'update', 'income-assets-info', 'complete'],
          {queryParams: {payment: 'trial-started'}}
        );
      });
  }
}
